export default __webpack_public_path__ + "static/media/case-study2.3019be1d.jpg";